// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import i18n from '@/locale'
import ViewUI, { Message } from 'view-design'
import '@/assets/icons/iconfont.css'
import config from '@/config'
import comConfig from '@/common/config'
import mixCommon from '@/common/mixCommon.js'
import '@/common/resize.js'
import importDirective from '@/directive'
import installPlugin from '@/plugin'
import './index.less'
import '@/assets/icons/iconfont.css'
import TreeTable from 'tree-table-vue'
import VOrgTree from 'v-org-tree'
import 'v-org-tree/dist/v-org-tree.css'
import Methods from '@/libs/methods.js'
import indexDb from '@/libs/IndexedDB.js'
import axios from 'axios'
import ChooseFile from '@/components/choose-file'
import request from '@/libs/api.request'
import PortalVue from 'portal-vue'
import { startVersionCheck } from '@/utils/version-check'

import 'view-design/dist/styles/iview.css'

import { notice } from './utils/notice';
Vue.prototype.$notice = notice;

import CustomNotification from '@/components/CustomNotification/CustomNotification';

Vue.component('CustomNotification', CustomNotification);



import UploadingToast from '_c/lazyLoading';
Vue.component('UploadingToast', UploadingToast);

import CommonPage from '_c/commonPage';
Vue.component('CommonPage', CommonPage);



function forceRefresh() {
  // 设置只强制刷行一次页面
  if (confirm('检测到新版本更新，确认：现在刷新，取消：稍后手动刷新！')) {
    window.location.reload(true)
  } else {
    console.log('稍后手动刷新')
  }
}

window.addEventListener('error', (error) => {
  console.log('页面报错', error)
  // const pattern = /Loading chunk (\d)+ failed/g;
  let pattern = /Loading chunk (\S)+ failed/g
  let isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    forceRefresh()
  }
  // let errorMsg = 'Uncaught SyntaxError: Unexpected token \'<\''
  // if (error.filename && error.filename.indexOf(window.location.host) > -1) {
  //   console.log('同源文件获取不到')
  //   if (error.message == errorMsg) {
  //     forceRefresh()
  //   }
  // }
})

window.addEventListener('unhandledrejection', function (event) {
  console.log('页面报错 unhandledrejection', event)
  // event.reason // 获取到catch的err的原因(内容) 与控制台报错一致
  // event.promise // 获取到未处理的promise对象
  let pattern = /Loading chunk (\S)+ failed/g
  let isChunkLoadFailed = event.reason?.message.match(pattern)
  if (isChunkLoadFailed) {
    forceRefresh()
  }
})

window.$request = request
window.$message = Message

Vue.prototype.Methods = Methods
// Vue.prototype.MenuMethods = MenuMethods
// Vue.prototype.MenuNewMethods = MenuNewMethods
Vue.prototype.$http = axios
// const on = Vue.prototype.$on
// // 防抖
// Vue.prototype.$on = function (event, func) {
//   let timer
//   let newFunc = func
//   if (event === 'click') {
//       newFunc = function () {
//           clearTimeout(timer)
//           timer = setTimeout(function () {
//               func.apply(this, arguments)
//           }, 1000)
//       }
//   }
//   on.call(this, event, newFunc)
// }

// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')
// import VueClipboard from 'vue-clipboard2'
// Vue.use(VueClipboard)

// Vue.prototype.dateTypeFormat = function(fmt, date) {
//   let ret
//   const opt = {
//     'Y+': date.getFullYear().toString(), // 年
//     'm+': (date.getMonth() + 1).toString(), // 月
//     'd+': date.getDate().toString(), // 日
//     'H+': date.getHours().toString(), // 时
//     'M+': date.getMinutes().toString(), // 分
//     'S+': date.getSeconds().toString() // 秒
//     // 有其他格式化字符需求可以继续添加，必须转化成字符串
//   }
//   for (const k in opt) {
//     ret = new RegExp('(' + k + ')').exec(fmt)
//     if (ret) {
//       fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
//     }
//   }
//   return fmt
// }

Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
});
// Vue.component('Table', Table);
Vue.use(TreeTable)
Vue.use(VOrgTree)
Vue.use(mixCommon)
// Vue.use(resize)
Vue.use(ChooseFile)
Vue.use(PortalVue)
// Vue.use(ElementUI)
// import RadioMeGroup from '@jyq-component/radioMeGroup/radioMeGroup'
// Vue.use(RadioMeGroup);
// Vue.component('RadioMeGroup', RadioMeGroup)

//自定义封装组件  start
// import Input from '@jyq-component/input/input.vue'
// Vue.use(Input);
// Vue.component('Input', Input)
// import InputNumber from '@jyq-component/iview-com/components/input-number/index'
// Vue.use(InputNumber);
// Vue.component('InputNumber', InputNumber)
// import Form from '@jyq-component/iview-com/components/form/index'
// Vue.use(Form);
// Vue.component('Form', Form)
// import FormItem from '@jyq-component/iview-com/components/form-item/index'
// Vue.use(FormItem);
// Vue.component('FormItem', FormItem)
// import Tooltip from '@jyq-component/iview-com/components/tooltip/index'
// Vue.use(Tooltip);
// Vue.component('Tooltip', Tooltip)
// import Step from '@jyq-component/iview-com/components/step/index'
// Vue.use(Step);
// Vue.component('Step', Step)
// import Steps from '@jyq-component/iview-com/components/steps/index'
// Vue.use(Steps);
// Vue.component('Steps', Steps)

// import Table from '@jyq-component/iview-com/components/table/table.vue'
// Vue.use(Table);
// Vue.component('Table', Table)
//自定义封装组件  end


// Vue.use(ViewUI);
Vue.prototype.axios = axios;

// 请求的拦截器
axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
})

/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
Vue.prototype.comConfig = comConfig
Vue.prototype.mixCommon = mixCommon
Vue.prototype.getFileH = mixCommon.getFileH
Vue.prototype.fileDownload = mixCommon.fileDownload
Vue.prototype.findkeyIndex = mixCommon.findkeyIndex
Vue.prototype.dowonldUrlFile = mixCommon.dowonldUrlFile
Vue.prototype.changeTImeStamp = mixCommon.changeTImeStamp
Vue.prototype.changeTimeDate = mixCommon.changeTimeDate
Vue.prototype.downloadFile = mixCommon.downloadFile
Vue.prototype.copyArr = mixCommon.copyArr
Vue.prototype.formatMethods = mixCommon.formatMethods
Vue.prototype.openFile = mixCommon.openFile
Vue.prototype.validComForm = mixCommon.validComForm
Vue.prototype.Trim = mixCommon.Trim
Vue.prototype.changePrice = mixCommon.changePrice
Vue.prototype.deepCopy = mixCommon.deepCopy
Vue.prototype.getImgUrl = mixCommon.getImgUrl
Vue.prototype.$pxTransform = mixCommon.pxTransform
Vue.prototype.setThousandsMark = mixCommon.setThousandsMark
Vue.prototype.findNode = mixCommon.findNode
Vue.prototype.getTimeText = mixCommon.getTimeText
Vue.prototype.getFblWidth = mixCommon.getFblWidth
Vue.prototype.$notice = notice;


Vue.prototype.$indexDB = indexDb

// 将 Message 挂载到 Vue.prototype 上
Vue.prototype.$Message = Message;

/**
 * 注册指令
 */
importDirective(Vue)
Vue.directive('preventReClick', {
  inserted(el, binding) {
    // debugger
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        el.style.pointerEvents = 'none'
        el.style.opacity = 0.5
        setTimeout(() => {
          el.disabled = false
          el.style.pointerEvents = ''
          el.style.opacity = 1
        }, binding.value || 2000)
      }
    })
  }
})
Vue.directive('preventReClick2', {
  inserted(el, binding) {
    // debugger
    el.addEventListener('click', () => {
      if (!el.disabled) {
        store.commit('updateFlag', false)
        el.disabled = true
        el.style.pointerEvents = 'none'
        el.style.opacity = 0.5
      }
    })
  },
  componentUpdated(el, { value }) {
    if (value) {
      el.disabled = false
      el.style.pointerEvents = ''
      el.style.opacity = 1
    }
  }
})
// 动态审批流 start
// import CusDrawer from '@/view/components/nes-custom/cus-drawer/index'
// Vue.component('CusDrawer', CusDrawer); //初始化组件
Vue.config.productionTip = false;
Vue.directive('enterNumber', {
  bind: function (el, { value = 2 }) {
    el = el.nodeName == "INPUT" ? el : el.children[0]
    var RegStr = value == 0 ? `^[\\+\\-]?\\d+\\d{0,0}` : `^[\\+\\-]?\\d+\\.?\\d{0,${value}}`;
    el.addEventListener('keyup', function () {
      el.value = el.value.match(new RegExp(RegStr, 'g'));
      el.dispatchEvent(new Event('input'))
    })
  }
});

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    el.focus()
  }
});
// 动态审批流 end
// RequestCenter.interceptors.request.use((config) => {
//   return mixCommon.requestResponse(config, 'request', config.url)
// })
// RequestCenter.interceptors.response.use((response) => {
//   return mixCommon.requestResponse(response, 'response')
// })
// locale.i18n(() => null)

// 动态表单挂载
import { getSignature, } from '@/api/data'
//表单编辑器aip请求接口
window.$api = {
  getSignature,
}

startVersionCheck(300000, 'confirm')

/**
 * 拦截器
 */

//  RequestCenter.interceptors.request.use((config) => {
//   const { token } = sessionStorage
//   if (token) {
//     config.headers['accesstoken'] = token
//   }
//   return config
//  })
//  RequestCenter.interceptors.request.use((config) => {
//   return mixCommon.requestResponse(config, 'request', config.url)
//  })


//  RequestCenter.interceptors.response.use((response) => {
//   const { fullPath } = router.currentRoute
//   const writeList = ['transaction-management', 'service-provider-management', 'payment-management', 'store-management', 'device-management']
//   if (writeList.some((v) => fullPath.includes(v))) {
//     return response
//   } else {
//     const { status = 0, data: { code, msg } = {} } = response
//     if (status === 200 ) {
//       // 文件下载
//       if(response.headers['content-type'] == 'application/octet-stream;charset=UTF-8') {
//         return response
//       } else if ( code === 0) {
//         return response
//       } else {
//         response.data.msg = mixCommon.getV(response.data.msg)
//         Message.error(`${response.data.msg}`)
//         return response
//       }
//     } else {
//       Message.error(`${msg}`)
//       return Promise.reject(new Error(msg))
//     }
//   }
//  })
// RequestCenter.interceptors.response.use((response) => {
//   return mixCommon.requestResponse(response, 'response')
// })

// RequestCenter.interceptors.request.use((config) => {
//   const { headers, data, url } = config;
//   headers.lang = simpleI18n.lang ? simpleI18n.lang.replace(/-/g, '_') : simpleI18n.lang;
//   return mixCommon.requestResponse(config, 'request', config.url)
// })

// locale.i18n(() => null)
// let viewChange = zhCnView
// let viewname = 'zh-CN'
// switch (viewname) {
//   case 'zh-CN':
//     viewChange = zhCnView
//     break;
//   case 'en-US':
//     viewChange = enUsView
//     break;
//   case 'ru-RU':
//     viewChange = ruRuView
//     break;
//   default:
//     viewChange = zhCnView
//     break;
// }
// locale.use(viewChange);
// console.log('本地', simpleI18n.lang)
// simpleI18n.langChangeCallbck = (val) => {
//   localStorage.setItem('LANG_STORAGE', val);
//   // locale.use(viewChange);
// };
// Vue.use(simpleI18n);
// window.addEventListener('message', ({ data }) => {
//   if (data.type === 'switchLang') {
//     simpleI18n.switchLang(data.data);
//   }
// }, false);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})



